import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSnackbar, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import {
    FARM_ACTIVATED, FARM_SWITCHED, FARM_CREATED, FARM_EDITED, FARM_ARCHIVED,
    FARM_UNARCHIVED, FARM_ADDRESS_UPDATED, FARM_ADDRESS_UPDATE_FAILED
} from '../constants/messages';
import {
    GET_PLAN_TYPE_LIST, GET_USER_FARM_LIST_REQUEST, GET_USER_FARM_LIST,
    GET_FARM_LIST_REQUEST, GET_FARM_LIST, SET_CURRENT_FARM,
    GET_TIMEZONE_LIST, GET_FARM_ENTITY_INFO, GET_FARM_ENTITY_INFO_REQUEST,
    SET_FARM_SWITCHED, SET_FARM_ADDRESS, FARM_ADDRESS_SAVING, GET_FARM_STATS_FIELD, GET_FARM_STATS_FIELD_REQUESTING,
    SET_FARM_SETTINGS, GET_FARM_USERS_LIST, GET_FARM_USERS_LIST_REQUEST,
    UPDATE_CURRENT_FARM
} from '../constants/action-types';
import moment from 'moment';

export const planTypeList = data => ({ type: GET_PLAN_TYPE_LIST, payload: data });

export const userFarmListRequest = () => ({ type: GET_USER_FARM_LIST_REQUEST });

export const userFarmList = data => ({ type: GET_USER_FARM_LIST, payload: data });

export const farmListRequest = () => ({ type: GET_FARM_LIST_REQUEST });

export const farmList = payload => ({ type: GET_FARM_LIST, payload });

export const farmEntityInfoRequest = () => ({ type: GET_FARM_ENTITY_INFO_REQUEST });

export const farmEntityInfo = data => ({ type: GET_FARM_ENTITY_INFO, payload: data });

export const setCurrentFarm = data => ({ type: SET_CURRENT_FARM, payload: data });

export const updateCurrentFarm = data => ({ type: UPDATE_CURRENT_FARM, payload: data });

export const farmSwitched = payload => ({ type: SET_FARM_SWITCHED, payload });

export const timezoneList = payload => ({ type: GET_TIMEZONE_LIST, payload });

export const setFarmAddress = payload => ({ type: SET_FARM_ADDRESS, payload });

export const setFarmSettings = payload => ({ type: SET_FARM_SETTINGS, payload });

export const farmAddressSaving = (data) => ({ type: FARM_ADDRESS_SAVING, payload: data });

export const farmStatsField = payload => ({ type: GET_FARM_STATS_FIELD, payload });

export const farmStatsFieldRequesting = () => ({ type: GET_FARM_STATS_FIELD_REQUESTING });

export const farmUsersList = payload => ({ type: GET_FARM_USERS_LIST, payload });

export const farmUsersListRequesting = () => ({ type: GET_FARM_USERS_LIST_REQUEST });

export const getUserFarmList = () => dispatch => {
    dispatch(userFarmListRequest());
    defaultAgent.get('api/user/farm/list', { __version: 1 }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(userFarmList(agentResult.data));
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getFarmList = (haveRequest = true) => dispatch => {
    if (haveRequest) dispatch(farmListRequest());
    const params = { with_access_code: 1 };

    defaultAgent.get('api/farm/list', params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(farmList(agentResult.data));
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getFarmEntityInfo = params => dispatch => {
    dispatch(farmEntityInfoRequest());
    defaultAgent.get('api/farm/entity/info', params)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(farmEntityInfo());
            } else if (agentResult.data) {
                dispatch(farmEntityInfo(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(farmEntityInfo());
        })
}

export const getTimeZoneList = () => dispatch => {
    defaultAgent.get('api/farm/timezonelist').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data)
            dispatch(timezoneList(agentResult.data));
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const switchFarm = (farmId, cb) => dispatch => {
    defaultAgent.put('api/user/farm/switch', { farm_uuid: farmId, __version: 1 }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_ACTIVATED.code) {
            if (cb) cb();
        }
        else if (agentResult.code === FARM_SWITCHED.code) {
            if (cb) cb();
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => dispatch(toastError(ex.message)));
};

export const createFarm = (params, cb) => dispatch => {
    defaultAgent.post('api/farm/add', { ...params, __version: 1 }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_CREATED.code) {
            if (cb) cb(true);
            dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message) {
            if (cb) cb(false);
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message))
    });
};

export const editFarm = (params, cb) => dispatch => {
    defaultAgent.post('api/farm/edit', { ...params }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_EDITED.code) {
            if (cb) cb();
            dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message))
    });
};

export const generateAccessCode = (farmId) => dispatch => {
    defaultAgent.get(`/api/farm/generate/accesscode?farm_uuid=${farmId}`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(getFarmList());
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getPlanTypeList = () => dispatch => {
    defaultAgent.get('/api/farm/plantype').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(planTypeList(agentResult.data));
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(planTypeList());
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(planTypeList());
    });
};

export const archivedFarm = (params, cb) => dispatch => {
    defaultAgent.post('api/farm/archived', { farm_uuid: params.farmId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastSnackbar(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_ARCHIVED.code) {
            if (cb) cb();
            dispatch(toastSnackbar(agentResult.message));
        } else if (agentResult.message) {
            dispatch(toastSnackbar(agentResult.message));
        }
    }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message))
    });
};

export const unArchivedFarm = (params, cb) => dispatch => {
    defaultAgent.post('api/farm/un-archived', { farm_uuid: params.farmId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastSnackbar(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_UNARCHIVED.code) {
            if (cb) cb();
            dispatch(toastSnackbar(agentResult.message));
        } else if (agentResult.message) {
            dispatch(toastSnackbar(agentResult.message));
        }
    }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message))
    });
};

export const getFarmAddress = (farmId) => dispatch => {
    defaultAgent.get(`/api/farm/address?farm_uuid=${farmId}`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setFarmAddress(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getFarmSettings = params => dispatch => {
    defaultAgent.get(`/api/farm/settings`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setFarmSettings(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const updateFarmSettings = (params, cb) => dispatch => {
    defaultAgent.put(`/api/farm/settings`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            dispatch(farmAddressSaving(false));
        }
        else if (agentResult.message && agentResult.code) {
            agentResult.code === 3031 ? dispatch(toastSuccess(agentResult.message)) : dispatch(toastError(agentResult.message));
            dispatch(farmAddressSaving(false));
            if (cb) cb();
        }
    }).catch(ex => dispatch(toastError(ex.message)));
};

export const saveFarmAddress = (params, cb) => dispatch => {
    dispatch(farmAddressSaving(true));
    defaultAgent.post(`/api/farm/address`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.code === FARM_ADDRESS_UPDATED.code) {
            if (cb) cb();
            dispatch(farmAddressSaving(false));
            //dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.code === FARM_ADDRESS_UPDATE_FAILED.code) {
            dispatch(toastError(agentResult.message));
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};

export const getFarmStatsField = (reqParams) => dispatch => {
    let { summaryType } = reqParams;
    if (summaryType) delete reqParams['summaryType'];
    defaultAgent.get(`/api/plan/load/v1/history`, reqParams).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            const dateOryear = (summaryType === 'year') ? moment(reqParams.from_date).year()
                : moment(reqParams.from_date).format('YYYY-MM-DD');
            const dt = {
                [`${dateOryear}`]: agentResult.data
            }
            dispatch(farmStatsField(dt));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
}

export const getFarmUsersList = farmId => dispatch => {
    dispatch(farmUsersListRequesting());
    defaultAgent.get(`/api/farm/user/assigned?farm_uuid=${farmId}`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(farmUsersList(agentResult.data));
        }
        else if (agentResult.message)
            dispatch(toastError(agentResult.message));
    }).catch(ex => {
        dispatch(toastError(ex.message));
    });
};